import { DOWN_AND_DISTANCE_KEY } from './selectors/filters';

const SET_ERROR = 'SET_ERROR';
const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
const SET_GENERAL_SETTINGS = 'SET_GENERAL_SETTINGS';
const SET_FOOTBALL_SETTINGS = 'SET_FOOTBALL_SETTINGS';
const CLEAR_VIEW = 'CLEAR_VIEW';
const TOGGLE_VIDEO_SETTINGS = 'TOGGLE_VIDEO_SETTINGS';
const SET_THUNDER_URL = 'SET_THUNDER_URL';
const TOGGLE_WEBSOCKET_CONNECT = 'TOGGLE_WEBSOCKET_CONNECT';
const SET_WEBSOCKET_MESSAGE = 'SET_WEBSOCKET_MESSAGE';
const TOGGLE_WEBSOCKET_ERROR = 'TOGGLE_WEBSOCKET_ERROR';
const SET_WEBSOCKET_PERCENT_DONE = 'SET_WEBSOCKET_PERCENT_DONE';
export const RESET_SETTINGS = 'RESET_SETTINGS';

const INITIAL_STATE = {
  activeView: null,
  thunder: {
    default: true, // default value is to launch video to Thunder
    url: '',
  },
  activeTab: DOWN_AND_DISTANCE_KEY,
  websocket: {
    connect: false,
    message: null,
    error: false,
    percentdone: '',
  },
  error: {
    status: false,
    location: null,
    message: '',
  },
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case SET_ACTIVE_TAB:
      return {
        ...state,
        activeTab: action.payload,
      };
    case SET_GENERAL_SETTINGS:
      return {
        ...state,
        activeView: 'general',
      };
    case SET_FOOTBALL_SETTINGS:
      return {
        ...state,
        activeView: 'football',
      };
    case CLEAR_VIEW:
      return {
        ...state,
        activeView: null,
      };
    case TOGGLE_VIDEO_SETTINGS:
      return {
        ...state,
        thunder: {
          ...state.thunder,
          default: action.payload,
        },
      };
    case SET_THUNDER_URL:
      return {
        ...state,
        thunder: {
          ...state.thunder,
          url: action.payload,
        },
      };
    case TOGGLE_WEBSOCKET_CONNECT:
      return {
        ...state,
        websocket: {
          ...state.websocket,
          connect: action.payload,
        },
      };
    case SET_WEBSOCKET_MESSAGE:
      return {
        ...state,
        websocket: {
          ...state.websocket,
          message: action.payload,
        },
      };
    case TOGGLE_WEBSOCKET_ERROR:
      return {
        ...state,
        websocket: {
          ...state.websocket,
          error: action.payload,
        },
      };
    case SET_WEBSOCKET_PERCENT_DONE:
      return {
        ...state,
        websocket: {
          ...state.websocket,
          percentdone: action.payload,
        },
      };
    case RESET_SETTINGS:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export function setError(payload) {
  return {
    type: SET_ERROR,
    payload,
  };
}

export function setView(payload) {
  return {
    type: payload === 'football' ? SET_FOOTBALL_SETTINGS : SET_GENERAL_SETTINGS,
  };
}

export function clearView() {
  return {
    type: CLEAR_VIEW,
  };
}

export function setActiveTab(payload) {
  return {
    type: SET_ACTIVE_TAB,
    payload,
  };
}

export function toggleVideoSettings(payload) {
  return {
    type: TOGGLE_VIDEO_SETTINGS,
    payload,
  };
}

export function setThunderUrl(payload) {
  return {
    type: SET_THUNDER_URL,
    payload,
  };
}

export function toggleWebsocketConnect(payload) {
  return {
    type: TOGGLE_WEBSOCKET_CONNECT,
    payload,
  };
}

export function setWebsocketMessage(payload) {
  return {
    type: SET_WEBSOCKET_MESSAGE,
    payload,
  };
}

export function toggleWebsocketError(payload) {
  return {
    type: TOGGLE_WEBSOCKET_ERROR,
    payload,
  };
}

export function setWebsocketPercentDone(payload) {
  return {
    type: SET_WEBSOCKET_PERCENT_DONE,
    payload,
  };
}
